import { useMemo, useState, useEffect } from 'react';
import * as R from 'ramda';
import MarketingReportComponent from '../components/smart/MarketingReportComponent';
import LoadingModal from '../components/dumb/LoadingModal';
import NotificationDisplay from '../components/dumb/NotificationDisplay';
import FunnelReportComponent from '../components/smart/FunnelReportComponent';
import TotalReportComponent from '../components/smart/report/TotalReportComponent';

const ReportTypes = {
    'MARKETING_REPORT': {
        key: 'MARKETING_REPORT',
        display: 'Marketing Report'
    },
    'COUNSELLOR_REPORT': {
        key: 'COUNSELLOR_REPORT',
        display: 'Counsellor Report'
    },
    'BATCH_FUNNEL_REPORT': {
        key: 'BATCH_FUNNEL_REPORT',
        display: 'Batch Funnel Report'
    },
    'TOTAL_REPORT': {
        key: 'TOTAL_REPORT',
        display: 'Total Report'
    }
};

function ReportPage() {
    const [selectedReportType, setSelectedReportType] = useState(ReportTypes.MARKETING_REPORT.key);

    const reportTypes = useMemo(() => {
        let keys = R.keys(ReportTypes);
        return R.map(key => ReportTypes[key])(keys);
    }, []);

    useEffect(() => {
        document.title = ReportTypes[selectedReportType].display;
    }, [selectedReportType])

    return (
        <>
            <div style={{ marginTop: '50px', marginLeft: '20px' }}>
                <h2> Generate Reports </h2>
                <div className="form-group">
                    <label> Select Report Type </label>
                    <select
                        onChange={e => setSelectedReportType(e.target.value)}
                        selected={selectedReportType}
                    >
                        {
                            reportTypes.map(reportType => <option key={reportType.key} value={reportType.key}> { reportType.display } </option>)
                        }
                    </select>
                </div>
                {
                    selectedReportType === ReportTypes.MARKETING_REPORT.key && (
                        <MarketingReportComponent />
                    )
                }
                {
                    selectedReportType === ReportTypes.BATCH_FUNNEL_REPORT.key && (
                        <FunnelReportComponent />
                    )
                }
                {
                    selectedReportType === ReportTypes.TOTAL_REPORT.key && (
                      <TotalReportComponent/>
                    )
                }
            </div>
        </>
    )
}

export default ReportPage;
